import React, { useContext, useEffect, useRef, useState } from 'react'
import url from '../../url'
// Context and labels
import { ApplicationContext } from '../application-context/application-context'
import BengaliLabels from './navbar-be'
import EnglishLabels from './navbar-en'
import GujratiLabels from './navbar-gu'
import HindiLabels from './navbar-hi'
import MarathiLabels from './navbar-ma'
import TeleguLabels from './navbar-te'
import TamilLabels from './navbar-tm'
import './search-style.css'

const SearchBox = ({ setActive }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [searchRes, setSearchRes] = useState([])
  const [activeElem, setActiveElem] = useState(-1)
  const languageContext = useContext(ApplicationContext)
  const searchRef = useRef(null)

  useEffect(() => {
  })
  let labels

  switch (languageContext.language) {
    case 'en':
      labels = EnglishLabels
      break
    case 'hi':
      labels = HindiLabels
      break
    case 'gu':
      labels = GujratiLabels
      break
    case 'ma':
      labels = MarathiLabels
      break
    case 'tm':
      labels = TamilLabels
      break
    case 'te':
      labels = TeleguLabels
      break
    case 'be':
      labels = BengaliLabels
      break
    default:
      labels = EnglishLabels
      break
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value)
    const giftcardSearch = window.fetch(`${url.meribachat}/search/names?q=${encodeURIComponent(e.target.value)}`)
      .then(res => {
        if (res.status === 200) return res.json()
        else throw new Error('Invalid response')
      })
      .then(body => { return body.brands.map((elem) => { elem.type = 'giftcard'; return elem }) })
      .catch(console.log)
    const cashbackSearch = window.fetch(`${url.affiliate}/brands/search/name?query=${encodeURIComponent(e.target.value)}`)
      .then(res => {
        if (res.status === 200) return res.json()
        else throw new Error('Invalid response')
      })
      .then(body => { return body.brands.map((elem) => { elem.type = 'cashback'; return elem }) })
      .catch(console.log)
    Promise.all([giftcardSearch, cashbackSearch]).then(([giftcardSearchRes, cashbackSearchRes]) => {
      let brands = []
      if (giftcardSearchRes) {
        brands = [...giftcardSearchRes]
      }
      if (cashbackSearchRes) {
        brands = [...brands, ...cashbackSearchRes]
      }
      setSearchRes(brands)
    })
  }

  const handleSearchKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setActiveElem(Math.min(activeElem + 1, searchRes.length - 1))
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      setActiveElem(Math.max(activeElem - 1, -1))
    }
    if (e.key === 'Enter') {
      e.preventDefault()
      if (activeElem >= 0) {
        if (searchRes[activeElem].type === 'giftcard') {
          if (window.fbq) {
            window.fbq('track', 'Search', {
              content_ids: [searchRes[activeElem]._id],
              content_category: 'product',
              search_string: searchTerm
            })
          }
          window.location.assign(`/brand/${searchRes[activeElem].urlName}`)
        }
        if (searchRes[activeElem].type === 'cashback') {
          if (window.fbq) {
            window.fbq('track', 'Search', {
              content_ids: [searchRes[activeElem]._id],
              content_category: 'product',
              search_string: searchTerm
            })
          }
          window.location.assign(`/cashback/brand/${searchRes[activeElem].urlName}`)
        }
      }
    }
  }

  return (
    <form
      className='search-box form-inline my-2 my-md-0' onSubmit={(e) => e.preventDefault()}
    >
      <input
        class='form-control'
        type='text'
        placeholder='Search...'
        value={searchTerm}
        onChange={handleSearchChange}
        name='search-term'
        onKeyDown={handleSearchKeyDown}
        autoComplete='off'
        ref={searchRef}
        style={
          languageContext.language !== 'en'
            ? {
              fontSize: '16px'
            }
            : {}
        }
      />
      <button type='submit'><i class='fa fa-search' /></button>
      <div className={`search-result ${searchTerm === '' || searchRes.length === 0 ? 'hide' : ''}`}>
        {searchRes.map((result, index) => {
          if (result.type === 'giftcard') {
            return (
              <div
                key={result._id}
                onClick={() => {
                  if (window.fbq) {
                    window.fbq('track', 'Search', {
                      content_ids: [result._id],
                      content_category: 'product',
                      search_string: searchTerm,
                      content_type: 'product'
                    })
                  }
                  window.location.assign(`/brand/${result.urlName}`)
                }}
              >
                <div className={`${activeElem === index ? 'active search-result-list' : 'search-result-list'}`}>{result.name}</div>
              </div>
            )
          }
          if (result.type === 'cashback') {
            return (
              <div
                key={result._id}

                onClick={() => {
                  if (window.fbq) {
                    window.fbq('track', 'Search', {
                      content_ids: [result._id],
                      content_category: 'product',
                      search_string: searchTerm
                    })
                  }
                  window.location.assign(`/cashback/brand/${result.urlName}`)
                }}
              >
                <div className={`${activeElem === index ? 'active search-result-list' : 'search-result-list'}`}>{result.brandName}</div>
              </div>
            )
          }
        })}
      </div>
      {/* <button type='submit' className='search-btn'>
        <img src={Search} alt='search' />
      </button> */}
      {/* <button
        type='button'
        className='close-btn'
        onClick={() => { if (setActive) { setActive(false) } }}
      >
        <img
          src={Close}
          alt='close'
          height='12'
          width='12'
          style={{ margin: 'auto 0', marginTop: '5px' }}
        />
      </button> */}
    </form>
  )
}

export default SearchBox
